import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function Inbox() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await axios.get("https://ma-laravel.ma-uae.com/api/emails");
      // API بترجع Array مش object
      setMessages(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch email. Please try again.",
      });
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will delete the email permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Close",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`https://ma-laravel.ma-uae.com/api/emails/${id}`);
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Email deleted successfully!",
        });
        fetchMessages();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete email. Please try again.",
        });
      }
    }
  };

  return (
    <section className="p-6">
      <h1 className="text-2xl font-bold mb-4">Inbox</h1>

      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 p-2">ID</th>
            <th className="border border-gray-300 p-2">Email</th>
            <th className="border border-gray-300 p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {messages.length > 0 ? (
            messages.map((message) => (
              <tr key={message.id}>
                <td className="border border-gray-300 p-2">{message.id}</td>
                <td className="border border-gray-300 p-2">{message.email}</td>
                <td className="border border-gray-300 p-2">
                  <button
                    className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                    onClick={() => handleDelete(message.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="3"
                className="text-center p-4 text-gray-500 italic"
              >
                No emails found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}
